import React from 'react';
import zohoStyles from './Zoho.styles';
const ZohoInstruction = () => {
    return (
        <>
            <div style={zohoStyles.container}>
                <div style={zohoStyles.instructionCard}>
                    <strong style={zohoStyles.strong}>INSTRUCTIONS : </strong>
                    <div>
                        <li>1. Each time you want to pull over Zoho data for a 1099 form, you must generate a 1099 report in your Zoho Books account. You must do this before you pull over data for 1099-MISC or 1099-NEC.</li>
                        <li>2. To generate a 1099 report in Zoho Books, go to "Reports" then "1099 Report". Match the Expense Accounts to the correct boxes then click "Generate Report". Once you have done this you can pull over the 1099 data through the Zoho integration in Tax1099.com.</li>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ZohoInstruction